import React from 'react'

import ZydusImage from '../../../assets/images/zydus-wellness-logo.png'

const Copyrights = () => {
  return (
    <section className="text-center pt-[50px] pb-[60px] font-[300] text-[12px] leading-[26px]">
      {`Copyright © ${new Date().getFullYear()} TatvaCare | All Rights Reserved`}
      <div className="flex justify-center items-center">
        <span>A Product by &nbsp;&nbsp;</span>
        <span>
          <img src={ZydusImage} height={40} width={50} />
        </span>
      </div>
    </section>
  )
}

export default Copyrights
